/* Rewrites every price the section script renders in hardcoded USD with the real,
   market-converted string emitted from Liquid (see snippets/luma-money.liquid).

   Two things this must get right, both found by testing as a German visitor:

   1. compare_at_price is NULL in the Europe market. The theme's hardcoded WAS map
      still printed "$79.00" next to a €51,95 price — a former price that never
      existed in euros, which is exactly what the EU Omnibus price-display rules are
      about. So when there is no compare-at in the current market we REMOVE the
      strikethrough rather than leave the dollar figure standing.

   2. The header currency label must not be matched by a naive /^[A-Z]{3}$/ test —
      the wordmark's "NYC" span matches it, and the brand rendered as "LUMAEUR".
      Anything inside .brand is now excluded, and we only replace text that is
      actually a currency token.

   Targets:
     #onepr    one-time price   -> <s>compare</s> price   (or just price)
     #subpr    subscribe price  -> <s>price</s> sub
     #stickypr sticky bar price -> sub when Subscribe is selected, else price
     .size .s2 .lwas            -> that variant's compare-at, or removed
     header currency label      -> the market's actual currency code

   Runs repeatedly and idempotently because the section script re-renders these nodes
   on every size / purchase-option click and we cannot hook its internals. */
(function(){
var M=window.LUMA_MONEY; if(!M||!M.variants) return;
var CURRENCIES=/^(USD|EUR|GBP|AUD|NZD|CHF|DKK|SEK|NOK|PLN|CAD|ILS)$/;

function variantOf(el){
  var inp=el.querySelector('input[value]');
  return inp ? String(inp.value) : null;
}
function selectedId(R){
  var active=R.querySelector('.size.active');
  if(active){ var id=variantOf(active); if(id) return id; }
  var any=R.querySelector('.size input[value]');
  return any?String(any.value):null;
}
function subActive(R){
  var sub=R.querySelector('.opt[data-type=sub]');
  return !!(sub && sub.classList.contains('active'));
}
function setHTML(el,html){ if(el && el.innerHTML!==html) el.innerHTML=html; }

function apply(){
  var R=document.querySelector('.lp'); if(!R) return;

  /* per-size strikethroughs */
  R.querySelectorAll('.size').forEach(function(sz){
    var id=variantOf(sz); if(!id) return;
    var d=M.variants[id]; if(!d) return;
    var was=sz.querySelector('.lwas');
    if(!was) return;
    if(d.compare){
      if(was.textContent!==d.compare) was.textContent=d.compare;
    }else{
      was.parentNode.removeChild(was);   /* no compare-at in this market */
    }
  });

  var id=selectedId(R); if(!id) return;
  var d=M.variants[id]; if(!d) return;

  var one=document.getElementById('onepr');
  if(one) setHTML(one, (d.compare?'<s>'+d.compare+'</s>':'')+d.price);

  var sub=document.getElementById('subpr');
  if(sub) setHTML(sub, '<s>'+d.price+'</s>'+d.sub);

  var sticky=document.getElementById('stickypr');
  if(sticky){
    var want=subActive(R)?d.sub:d.price;
    if(sticky.textContent.trim()!==want) sticky.textContent=want;
  }

  /* header currency label - the theme hardcodes "$ USD".
     Never touch the wordmark: its "NYC" span also matches a bare 3-letter test. */
  var hdr=R.querySelector('header'); if(!hdr) return;
  hdr.querySelectorAll('span,div,a').forEach(function(el){
    if(el.children.length) return;
    if(el.closest('.brand')) return;
    var t=(el.textContent||'').trim();
    var code=t.replace(/^[^A-Za-z]*/,'').trim();
    if(!CURRENCIES.test(code)) return;
    if(code===M.currency && t===M.currency) return;
    el.textContent=M.currency;
  });
}

function start(){
  apply();
  var R=document.querySelector('.lp');
  if(R && !R.dataset.lumaMoney){
    R.dataset.lumaMoney='1';
    R.addEventListener('click',function(e){
      if(e.target.closest && (e.target.closest('.size')||e.target.closest('.opt'))){
        setTimeout(apply,0); setTimeout(apply,60);
      }
    },false);
  }
}
document.addEventListener('DOMContentLoaded',function(){
  [80,400,900,1600,2600].forEach(function(t){ setTimeout(start,t); });
});
window.addEventListener('load',function(){ [300,1200].forEach(function(t){ setTimeout(start,t); }); });
})();